/** A data da liberação representa um dia do calendário, não um instante UTC. */
export const parseDataLiberacao = (value: string | null | undefined): Date | null => {
  if (!value) return null;

  return new Date(`${value.slice(0, 10)}T00:00:00`);
};
